import CurrencyList from 'currency-list';
import './utils/extraCurrencies';

global.USDSymbol = '$';

function currencyToText(currency, short, num = '') {
    // A currency we still don't know shows its code rather than nothing, so a price never disappears.
    if (!CurrencyList.get(currency)) {
        if (!currency) return '';
        return short ? `${currency} ${num}`.trim() : currency;
    }
    if (short) {
        return `${currency === 'USD' ? global.USDSymbol : CurrencyList.get(currency).symbol}${num}`;
    }

    return `${currency} (${currency === 'USD' ? global.USDSymbol : CurrencyList.get(currency).symbol})`;
}

export default currencyToText;
export const setupUSDSymbol = (symbol) => {
    global.USDSymbol = symbol;
}
